import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface OpcaoPerfil {
  id: string;
  nome: string;
}

export interface PerfilUsuario {
  nome: string;
  nomeSocial: string | null;
  email: string;
  perfil: string;
  telefone: string | null;
  sexoId: string | null;
  racaId: string | null;
  nacionalidade: string | null;
  naturalidade: string | null;
  setor: string | null;
  cargoId: string | null;
  dataNascimento: string | null;
  necessidadeEspeciaisIds: string[];
  midia: string | null;
  ultimoLogin: string;
}

export const PERFIS_PERFIL: OpcaoPerfil[] = [
  { id: 'administrador', nome: 'Administrador' }
];

export const CARGOS_PERFIL: OpcaoPerfil[] = [
  { id: 'gestor', nome: 'Gestor' },
  { id: 'analista', nome: 'Analista' }
];

export const SEXOS_PERFIL: OpcaoPerfil[] = [
  { id: 'feminino', nome: 'Feminino' },
  { id: 'masculino', nome: 'Masculino' },
  { id: 'nao-informado', nome: 'Prefiro não informar' }
];

export const RACAS_PERFIL: OpcaoPerfil[] = [
  { id: 'branca', nome: 'Branca' },
  { id: 'preta', nome: 'Preta' },
  { id: 'parda', nome: 'Parda' },
  { id: 'indigena', nome: 'Indígena' },
  { id: 'amarela', nome: 'Amarela' }
];

export const NECESSIDADES_PERFIL: OpcaoPerfil[] = [
  { id: 'visual', nome: 'Visual' },
  { id: 'auditiva', nome: 'Auditiva' },
  { id: 'motora', nome: 'Motora' }
];

@Injectable({ providedIn: 'root' })
export class PerfilUsuarioService {
  readonly perfis = PERFIS_PERFIL;
  readonly cargos = CARGOS_PERFIL;
  readonly sexos = SEXOS_PERFIL;
  readonly racas = RACAS_PERFIL;
  readonly necessidadesEspeciais = NECESSIDADES_PERFIL;

  private readonly perfilAtual = new BehaviorSubject<PerfilUsuario>(this.criarPerfilInicial());

  get perfil(): PerfilUsuario {
    return this.perfilAtual.value;
  }

  get perfil$(): Observable<PerfilUsuario> {
    return this.perfilAtual.asObservable();
  }

  atualizar(dados: Partial<PerfilUsuario>): void {
    this.perfilAtual.next({ ...this.perfilAtual.value, ...dados });
  }

  nomeExibicao(perfil: PerfilUsuario = this.perfil): string {
    return perfil.nomeSocial?.trim() || perfil.nome;
  }

  private criarPerfilInicial(): PerfilUsuario {
    return {
      nome: 'Usuário Administrativo',
      nomeSocial: 'Usuário Administrativo',
      email: 'usuario@sistema.local',
      perfil: PERFIS_PERFIL[0].nome,
      telefone: '(71) 99999-9999',
      sexoId: SEXOS_PERFIL[2].id,
      racaId: RACAS_PERFIL[2].id,
      nacionalidade: 'Brasileira',
      naturalidade: 'Salvador',
      setor: 'Administrativo',
      cargoId: CARGOS_PERFIL[0].id,
      dataNascimento: '1990-01-01',
      necessidadeEspeciaisIds: [],
      midia: null,
      ultimoLogin: new Date().toISOString()
    };
  }
}
